module.exports = __webpack_public_path__ + "static/img/btn_submit2.c01b332a.png";